import React from 'react';
import classNames from 'classnames';
import dayjs from 'dayjs';
import { CalendarFilledIcon, DocumentTextIcon, DollarCircleIcon } from 'icons';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

interface IProps {
  admissionStartDate?: string | null;
  admissionEndDate?: string | null;
  maxContractPrice?: string | null;
  minContractPrice?: string | null;
  file?: string | null;
}

const ExtraUniversityList: React.FC<IProps> = ({
  admissionStartDate,
  admissionEndDate,
  maxContractPrice,
  minContractPrice,
  file
}) => {
  const t = useTranslations();
  const visibleCount = [maxContractPrice && minContractPrice, admissionStartDate && admissionEndDate, file].filter(
    Boolean
  ).length;

  return (
    <div
      className={classNames('grid grid-cols-1 gap-3', {
        'sm:grid-cols-2': visibleCount <= 2,
        'md:grid-cols-3': visibleCount === 3
      })}
    >
      {maxContractPrice && minContractPrice && (
        <div className="flex items-center gap-3 rounded-xl bg-blue-100 px-3 py-2">
          <div className="flex size-8 items-center justify-center rounded-full bg-blue-500 text-white">
            <DollarCircleIcon />
          </div>
          <div>
            <span className="text-[0.7rem] text-gray-600">{t('kontrakt_tolovi')}</span>
            <p className="text-[0.813rem] font-semibold text-gray-900">
              {Number(minContractPrice).toLocaleString('ru')} - {Number(maxContractPrice).toLocaleString('ru')} UZS
            </p>
          </div>
        </div>
      )}
      {admissionStartDate && admissionEndDate && (
        <div className="flex items-center gap-3 rounded-xl bg-yellow-100 px-3 py-2">
          <div className="flex size-8 min-h-8 min-w-8 items-center justify-center rounded-full bg-yellow-500 text-white">
            <CalendarFilledIcon />
          </div>
          <div>
            <span className="text-[0.7rem] text-gray-600">{t('qabul_muddati')}</span>
            <p className="text-[0.813rem] font-semibold text-gray-900">
              {dayjs(Number(admissionStartDate) * 1000).format('DD.MM.YYYY')} -{' '}
              {dayjs(Number(admissionEndDate) * 1000).format('DD.MM.YYYY')}
            </p>
          </div>
        </div>
      )}
      {file && (
        <div className="flex items-center gap-3 rounded-xl bg-indigo-100 px-3 py-2">
          <div className="flex size-8 min-h-8 min-w-8 items-center justify-center rounded-full bg-indigo-500 text-white">
            <DocumentTextIcon />
          </div>
          <div>
            <span className="text-[0.7rem] text-gray-600">{t('otm_litsenziyasi')}</span>
            <p className="text-[0.813rem] font-semibold">
              <Link target="_blank" href={file} className="font-semibold text-indigo-600">
                {t('korish_va_yuklab_olish')}
              </Link>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExtraUniversityList;
